import styled from 'styled-components'

import MarketBooth1 from '~/shared/assets/images/marketbooth-1.png'
import MarketBooth2 from '~/shared/assets/images/marketbooth-2.png'
import MarketBooth3 from '~/shared/assets/images/marketbooth-3.png'
import MarketBooth4 from '~/shared/assets/images/marketbooth-4.png'
import MarketBooth5 from '~/shared/assets/images/marketbooth-5.png'
import MarketBooth6 from '~/shared/assets/images/marketbooth-6.png'
import MarketBooth7 from '~/shared/assets/images/marketbooth-7.png'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

function MarketBooth() {
  return (
    <Wrapper>
      <Booth>
        <Tag $size={'md'} $variant={'gray'}>
          마켓 부스
        </Tag>
        <div>자신이 좋아하는 작품의 2차 창작 굿즈를 직접 제작하여 판매</div>
        <ImageRow>
          <Image src={MarketBooth1} alt="Booth 1" />
          <Image src={MarketBooth2} alt="Booth 2" />
          <Image src={MarketBooth3} alt="Booth 3" />
        </ImageRow>
        <ImageRow>
          <FixedSizeImage src={MarketBooth4} alt="Booth 4" />
          <FixedSizeImage src={MarketBooth5} alt="Booth 5" />
          <FixedSizeImage src={MarketBooth6} alt="Booth 6" />
          <FixedSizeImage src={MarketBooth7} alt="Booth 7" />
        </ImageRow>
      </Booth>
    </Wrapper>
  )
}

export default MarketBooth

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  height: auto;
  margin: 0 auto; /* 중앙 정렬 */
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Booth = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ImageRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;

  @media ${theme.device.medium} {
    gap: 0; /* 모바일에서 이미지 간격을 제거 */
  }
`

const Image = styled.img`
  width: calc((100% - 32px) / 3); /* 3개의 이미지와 gap을 계산하여 너비 설정 */
  height: auto;

  /* object-fit: cover; */
  border-radius: 8px;

  @media ${theme.device.medium} {
    width: calc(100% / 3); /* 모바일에서 gap을 제거한 너비 설정 */
    height: 90px; /* 모바일에서 높이를 90px로 설정 */
    border-radius: 0; /* 모바일에서 border-radius 제거 */
  }
`

const FixedSizeImage = styled.img`
  width: calc((100% - 48px) / 4); /* 4개의 이미지와 gap을 계산하여 너비 설정 */
  height: 195px;
  object-fit: cover;
  border-radius: 8px;

  @media ${theme.device.medium} {
    width: calc(100% / 4); /* 모바일에서 gap을 제거한 너비 설정 */
    height: 52px; /* 모바일에서 높이를 90px로 설정 */
    border-radius: 0; /* 모바일에서 border-radius 제거 */
  }
`
